import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";
import {AutoComplete} from "material-ui";

const Theme = (borderRadius = '0 0 0 0', top = '-12px') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
                padding: '0.5px !important',
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: top,
                left: '10px'
            }
        },
        MuiAutocomplete: {
            input: {
                padding: '10px 14px !important',
            }
        },

    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});


const useStyles = makeStyles((theme) => ({
    padding: {},
}));

export default function (props) {
    const classes = useStyles();
    let val, setVal;
    if (!!props.value) {
        [val, setVal] = React.useState(props.value);
    } else {
        [val, setVal] = React.useState(!props.withLabel ? props.rowsPerPageOptions[0] : '');
    }
    useEffect(() => {
        setVal(typeof props.value !== "undefined" ? props.value : val)
    });
    const handleChange = (event, value = null) => {
        let a = typeof value !== 'object' ? value : event.target.value;
        props.onChange(a)
        setVal(props.value || a);
    };
    const type = props.type || 'select';
    return (
        <div style={props.styles}>
            {type === 'select' && <FormControl style={{width: props.width || '100%'}}>
            <ThemeProvider theme={Theme(props.borderRadius || '0 0 0 0')}>

                    {props.withLabel &&
                    <InputLabel id={"demo-customized-select-site" + props.name}>{props.label}</InputLabel>}
                    <Select
                        labelId={"demo-customized-select-site" + props.name}
                        id="demo-customized-select"
                        value={val}
                        name={props.name}
                        onChange={handleChange}
                        variant={'outlined'}
                        classes={classes}
                    >
                        {props.withEmpty && <MenuItem value={''}>
                            <em>{props.emptyName || 'None'}</em>
                        </MenuItem>}
                        {props.rowsPerPageOptions.map((elem) => {
                            return (
                                <MenuItem value={elem}>{elem}</MenuItem>
                            )
                        })
                        };
                    </Select>
            </ThemeProvider>
                </FormControl>

                }
                {type === 'autocomplete' &&
                <ThemeProvider theme={Theme(props.borderRadius || '0 0 0 0', '-7px')}    >
                <Autocomplete
                    classes={classes.padding}
                    style={{width: props.width || '100%'}}
                    id={"demo-customized-select-site" + props.name}
                    options={props.rowsPerPageOptions}
                    getOptionLabel={(option) => option}
                    onChange={handleChange}
                    value={val}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" label={props.label} placeholder={props.label}/>
                    )}
                />
                    </ThemeProvider>
                }

        </div>
    );
}
